import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import type { UserRole } from '@root/@types/types';

import { useUserStore } from './store';

interface ProtectedRoutesProps {
  authorizedRoles: UserRole[];
  fallbackPath?: string;
}

export const ProtectedRoutes: FC<ProtectedRoutesProps> = ({ authorizedRoles, fallbackPath = '/' }) => {
  const { isLoggedIn, user } = useUserStore(({ isLoggedIn, user }) => ({ isLoggedIn, user }));

  if (!isLoggedIn || !user?.role) {
    return null;
  }

  if (authorizedRoles.includes(user.role)) {
    return <Outlet />;
  }

  return <Navigate to={fallbackPath} />;
};
